import { render } from "./PrivacyComponent.vue?vue&type=template&id=1e7fd36f&scoped=true"
import script from "./PrivacyComponent.vue?vue&type=script&lang=js"
export * from "./PrivacyComponent.vue?vue&type=script&lang=js"

import "./PrivacyComponent.vue?vue&type=style&index=0&id=1e7fd36f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e7fd36f"]])

export default __exports__